module.exports = __webpack_public_path__ + "static/media/description-bg.e29d9cd3.jpg";